import { createContext, useContext } from 'react';

export const UI_CONTEXTS = {
  CONSORCIOS: 'CONSORCIOS',
  MI_ADMIN: 'MI_ADMIN',
};

export const UiSectionContext = createContext({
  uiContext: UI_CONTEXTS.CONSORCIOS,
  setUiContext: () => {},
});

export const useUiSectionContext = () => useContext(UiSectionContext);
